import { OnInit, OnDestroy, ElementRef, ViewChild, Directive } from '@angular/core';
import { MfeLoaderService, MfeLoadOptions } from 'src/app/MFE/mfe-loader.service';

@Directive()
export abstract class BaseMfeComponent implements OnInit, OnDestroy {
  @ViewChild('mfeContainer', { static: true }) mfeContainer!: ElementRef;

  protected abstract configKey: string;
  protected abstract tagName: string;
  protected abstract scriptPath: string;

  constructor(protected mfeLoaderService: MfeLoaderService) {}

  ngOnInit() {
    const options: MfeLoadOptions = {
      configKey: this.configKey,
      tagName: this.tagName,
      scriptPath: this.scriptPath,
      containerRef: this.mfeContainer,
    };
    this.mfeLoaderService.load(options);
  }

  ngOnDestroy() {
    this.mfeLoaderService.cleanupConfig(this.configKey);
  }
}
